(() => {
  if (window.__mobaiMeasurementInstalled || window.Shopify?.designMode) return;
  window.__mobaiMeasurementInstalled = true;
  const measurementId = 'G-BV80ZBCZN6';
  const qaKey = 'mobai_ga4_qa';
  const formKey = 'mobai_contact_pending';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  const params = new URLSearchParams(location.search);
  const isQA = () => window.mobaiQA ? window.mobaiQA.active : params.get('mobai_qa') !== '0' && (params.get('mobai_qa') === '1' || read(qaKey) === '1' || params.get('utm_campaign') === 'a002_qa' || ['qa/internal_test', 'mobai_qa/internal'].includes(params.get('utm_source') + '/' + params.get('utm_medium')));
  const safePage = () => {
    const page = location.origin + location.pathname + (params.get('view') === 'taiji' ? '?view=taiji' : '');
    return page + (isQA() ? (page.includes('?') ? '&' : '?') + 'mobai_qa=1' : '');
  };
  const send = (name, extra = {}, onQueued, onUnavailable) => {
    if (!allowed()) return;
    const started = Date.now();
    const attempt = () => {
      if (!allowed()) { onUnavailable?.(); return; }
      if (typeof window.gtag !== 'function') {
        if (Date.now() - started < 10000) setTimeout(attempt, 250);
        else onUnavailable?.();
        return;
      }
      const qa = isQA();
      window.gtag('event', name, {
        send_to: measurementId,
        page_location: safePage(),
        page_path: location.pathname,
        ...extra,
        ...(qa ? {debug_mode: true, traffic_type: 'internal', qa_test: 'mobai_qa'} : {})
      });
      onQueued?.();
    };
    attempt();
  };
  document.addEventListener('click', event => {
    const link = event.target?.closest?.('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.origin); } catch { return; }
    let name;
    if (url.protocol === 'https:' && url.hostname === 'wa.me' && url.pathname === '/8615052181380') name = 'whatsapp_click';
    if (url.protocol === 'mailto:' && url.pathname.toLowerCase() === 'hellomobai@163.com') name = 'email_click';
    if (!name) return;
    const placement = link.matches('[data-whatsapp-float]') ? 'floating'
      : link.classList.contains('mobai-whatsapp-product') ? 'product'
      : link.closest('#shopify-section-mobai-footer') ? 'footer' : 'contact_page';
    send(name, {contact_channel: name === 'whatsapp_click' ? 'whatsapp' : 'email', contact_placement: placement});
  }, {capture: true});
  document.addEventListener('submit', event => {
    if (event.target?.id === 'mobai-contact-form' && allowed()) write(formKey, String(Date.now()));
  }, {capture: true});
  const checkSuccess = () => {
    checkReservationSuccess();
  const pendingAt = Number(read(formKey));
  if (pendingAt && Date.now() - pendingAt >= 0 && Date.now() - pendingAt < 10 * 60 * 1000 && document.querySelector('#mobai-contact-form .native-success[role="status"]')) {
    send('contact_submit_success', {contact_channel: 'contact_form'}, () => remove(formKey));
  } else if (pendingAt && Date.now() - pendingAt >= 10 * 60 * 1000) remove(formKey);
  };
  const reservationKey = 'mobai_reservation_pending';
  const reservationProducts = new Map([
    ['9563801157871', 1], ['9563801026799', 1],
    ['9563801092335', 1], ['9563801125103', 1],
    ['9565749870831', 4]
  ]);
  let reservationSending = false;
  document.addEventListener('submit', event => {
    if (event.target?.id !== 'mobai-bookmark-reservation-form' || !allowed()) return;
    const root = event.target.closest('[data-reservation-product]');
    const productId = root?.getAttribute('data-reservation-product');
    const units = reservationProducts.get(productId);
    const count = Number(event.target.querySelector('[name="contact[requested_items]"]')?.value);
    if (!units || !Number.isSafeInteger(count) || count < 1) return;
    // No customer email, message, name or contact consent value is read or stored.
    write(reservationKey, JSON.stringify({
      submitted_at: Date.now(), page_path: location.pathname,
      product_id: productId, units_per_item: units, reservation_items: count
    }));
  }, {capture: true});
  function checkReservationSuccess() {
    if (!allowed() || reservationSending) return;
    let pending;
    try { pending = JSON.parse(read(reservationKey) || 'null'); } catch { remove(reservationKey); return; }
    if (!pending) return;
    const age = Date.now() - pending.submitted_at;
    if (!Number.isFinite(age) || age < 0 || age >= 10 * 60 * 1000) { remove(reservationKey); return; }
    const units = reservationProducts.get(pending.product_id);
    if (!units || units !== pending.units_per_item || !Number.isSafeInteger(pending.reservation_items) || pending.reservation_items < 1) { remove(reservationKey); return; }
    const root = document.querySelector('[data-reservation-product]');
    if (pending.page_path !== location.pathname || root?.getAttribute('data-reservation-product') !== pending.product_id ||
        !root.querySelector('#mobai-bookmark-reservation-form [data-reservation-success][role="status"]')) return;
    reservationSending = true;
    send('bookmark_reservation_success', {
      reservation_product_id: pending.product_id,
      reservation_items: pending.reservation_items,
      units_per_item: units,
      reservation_type: units === 4 ? 'four_seasons_set' : 'single_design',
      count_basis: 'per_design'
    }, () => { remove(reservationKey); reservationSending = false; }, () => {
      reservationSending = false;
      // Retain confirmed-success evidence while the Google tag loads late.
      // Expiry, product/path checks and consent still apply on every retry.
      if (allowed()) setTimeout(checkReservationSuccess, 2000);
    });
  }
  const initPrivacy = () => {
    if (window.Shopify?.customerPrivacy) { checkSuccess(); return; }
    if (typeof window.Shopify?.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) { checkSuccess(); scanFinder(); }
    });
  };
  // Taiji funnel: public UI state only. Never read forms, birth details or poster signatures.
  const isFinder = () => document.body?.classList.contains('mobai-finder-page');
  let finderSeen = false, lastFinderStage = '', lastPoster = null;
  const finderSend = (name, extra = {}) => {
    if (!isFinder() || !allowed()) return;
    send(name, {experience: 'taiji', ...extra});
  };
  const scanFinder = () => {
    if (!isFinder() || !allowed()) return;
    const root = document.getElementById('root');
    if (!root) return;
    const stage = root.querySelector('main.stage');
    if (!stage) return;
    if (!finderSeen) { finderSeen = true; finderSend('taiji_view'); }
    const state = ['intro','revealing','results','questions','birth','browse'].find(s => stage.classList.contains('stage-' + s)) || '';
    if (state !== lastFinderStage) {
      lastFinderStage = state;
      if (state === 'results') finderSend('taiji_result_view');
    }
    const poster = root.querySelector('.poster-dialog[open]');
    if (poster && poster !== lastPoster) finderSend('taiji_poster_open');
    lastPoster = poster;
  };
  document.addEventListener('click', event => {
    if (!isFinder() || !allowed()) return;
    const el = event.target?.closest?.('button,a');
    if (!el) return;
    if (el.closest('.intro') && el.matches('.primary,.taiji-button')) {
      finderSend('taiji_start');
    }
    const product = el.closest('.result-grid a.product-image-link');
    if (product) {
      let url;
      try { url = new URL(product.href, location.origin); } catch { return; }
      if (url.origin !== location.origin || !/^\/(?:zh\/)?products\//.test(url.pathname)) return;
      const variant = url.searchParams.get('variant');
      finderSend('taiji_product_click', {item_path: url.pathname, ...(variant && /^\d+$/.test(variant) ? {item_id: variant} : {})});
    }
    if (el.matches('.poster-actions a[download]') && el.getAttribute('aria-disabled') !== 'true') finderSend('taiji_poster_save_click');
  }, {capture: true});
  const finderRoot = document.getElementById('root');
  if (isFinder() && finderRoot) {
    // Observe screen/dialog state, never per-frame animation styles or form values.
    const finderObserver = new MutationObserver(scanFinder);
    const observeFinder = () => finderObserver.observe(finderRoot, {childList:true,subtree:true,attributes:true,attributeFilter:['class','open']});
    observeFinder();
    window.addEventListener('pagehide', () => finderObserver.disconnect());
    window.addEventListener('pageshow', event => { if (event.persisted) { observeFinder(); scanFinder(); } });
    document.addEventListener('visitorConsentCollected', scanFinder);
    scanFinder();
  }
  initPrivacy();
  document.addEventListener('visitorConsentCollected', checkSuccess);
})();
